import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all userses
export const getUserses = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/users`);
    return response.data;
  } catch (error) {
    console.error("Error fetching userses:", error.response?.data || error);
    throw error;
  }
};

// GET a single users
export const getUsersById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/users/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new users
export const createUsers = async (usersData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/users`, usersData);
    return response.data;
  } catch (error) {
    console.error("Error creating users:", error.response?.data || error);
    throw error;
  }
};

export const createDisplayOnlyUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/users/createdDisplayOnlyUser`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error('Error creating display only user:', error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing users
export const updateUsers = async (id, usersData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/users/${id}`, usersData);
    return response.data;
  } catch (error) {
    console.error("Error updating users:", error.response?.data || error);
    throw error;
  }
};

// DELETE a users
export const deleteUsers = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/users/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting users:", error.response?.data || error);
    throw error;
  }
};
